module.exports = __webpack_public_path__ + "static/media/biaoji.6db33dc9.svg";